import React from 'react';
import { Icon } from '../Description/DescriptionElements';
import { TestimonialsBackground } from '../Testimonials/TestimonialsElements';


const Equipment = () => {
    return (
        <TestimonialsBackground>
            <Icon to="/">TMN</Icon>
        </TestimonialsBackground>
    );
};

export default Equipment;